export default function fixCurrencyValue(amount?: number): number | string {
    if (!amount) {
        return "";
    }

    let newAmount = amount.toString();
    const converted = newAmount.split(".");
    
    if (converted.length > 1) {
        if (converted[1].length < 2) {
            newAmount = `${converted[0]}.${converted[1]}0`;
        } else if (converted[1].length > 2) {
            newAmount = `${converted[0]}.${converted[1].substring(0, 2)}`;
        }
    }

    try {
        return Number(newAmount);
    } catch {
        return newAmount;
    }
}